module.exports = __webpack_public_path__ + "img/offShelf.52f82525.svg";